import { DOCUMENT } from '@angular/common';
import { OnInit, Component, Inject } from '@angular/core';
import { AuthService, WindowService } from 'src/app/service/api';
import { environment } from 'src/environments/environment';

@Component({
  templateUrl: 'timeout.component.html',
  styleUrls: ['timeout.component.scss'],
})
export class TimeoutComponent implements OnInit {
  private _window: WindowService;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private windowService: WindowService,
    private authService: AuthService
  ) {
    this._window = this.windowService;
  }

  ngOnInit() {
    const gnbElement = this.document.getElementById('gnb');
    gnbElement.style.display = 'none';
  }

  signIn() {
    const href = this.authService.getSafeUrl(`${this._window.nativeWindow.location.href}`);
    this._window.open(`${environment.api}/oauth2/authorization/samsung?redirect_uri=${href}`, '_self');
  }
}
